import { render, staticRenderFns } from "./listaProduccion.vue?vue&type=template&id=8b976528"
import script from "./listaProduccion.vue?vue&type=script&lang=js"
export * from "./listaProduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports